module.exports = __webpack_public_path__ + "static/img/10.24b28a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/question/10.png
// module id = 75m3
// module chunks = 1